module.exports = __webpack_public_path__ + "img/health_status_icon4.9e7a72d5.png";